import { z as e } from "../../zod.BRvRcVQy.js";
var l = /* @__PURE__ */ ((t) => (t.INTERSECT = "intersect", t.UNION = "union", t.DIFF = "diff", t))(l || {}), i = /* @__PURE__ */ ((t) => (t.CONTAINS_ANY_OF = "contains_any_of", t.CONTAINS_NONE_OF = "contains_none_of", t.CONTAINS_ALL_OF = "contains_all_of", t.EMPTY = "empty", t.NOT_EMPTY = "not_empty", t))(i || {}), o = /* @__PURE__ */ ((t) => (t.AND = "and", t.OR = "or", t))(o || {});
const n = e.object({
  attribute: e.string().trim().min(1),
  condition: e.nativeEnum(i),
  values: e.array(e.string()).nullable()
}), m = n.extend({
  attribute: n.shape.attribute.nullable(),
  condition: n.shape.condition.nullable()
}), r = e.object({
  filters: e.array(n.refine((t) => [
    "empty",
    "not_empty"
    /* NOT_EMPTY */
  ].includes(t.condition) && !t.values?.length || ![
    "empty",
    "not_empty"
    /* NOT_EMPTY */
  ].includes(t.condition) && t.values?.length, {
    message: "Values must be empty for conditions 'empty' and 'not_empty'",
    path: ["values"]
  })),
  operator: e.nativeEnum(o)
}), s = r.extend({
  filters: m.array()
}), a = e.object({
  filters: e.optional(e.nullable(r)),
  name: e.string().trim().min(1),
  operator: e.nativeEnum(l),
  source_ref: e.string().trim().min(1)
}), u = a.extend({
  filters: e.optional(e.nullable(s)),
  source_ref: e.string().trim().min(1).nullable()
}), c = e.object({
  combine: e.optional(e.nullable(e.array(a))),
  filters: e.optional(e.nullable(r)),
  id: e.string().trim().min(1),
  name: e.string().trim().min(1),
  source_ref: e.string().trim().min(1)
});
c.extend({
  combine: e.optional(e.nullable(e.array(u))),
  filters: e.optional(e.nullable(s)),
  source_ref: e.string().trim().min(1).nullable()
}).omit({
  id: !0
});
var _ = /* @__PURE__ */ ((t) => (t.NUMERIC_RANGE = "NUMERIC_RANGE", t.CATEGORICAL = "CATEGORICAL", t))(_ || {});
export {
  _ as AudienceAttributeValueType,
  l as AudienceCombinatorOperator,
  i as AudienceCondition,
  o as AudienceFiltersBooleanOperator,
  c as audienceRulesTreeSchema
};
//# sourceMappingURL=models.js.map
